import React, { useEffect, useState } from 'react';

import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import { queries } from 'RestAPIs/rapini';

import { Paper, Tabs, Tab, Box } from '@mui/material';

import CostCalculationExternalMonth from 'components/employee-card/cost-calculation-external/CostCalculationExternalMonth';
import CostCalculationExternalYear from 'components/employee-card/cost-calculation-external/CostCalculationExternalYear';
import { Select, TabPanel } from 'components/shared';
import StyledTabs from 'components/shared/StyledTabs';

const months = {
  1: 'january',
  2: 'february',
  3: 'march',
  4: 'april',
  5: 'may',
  6: 'june',
  7: 'july',
  8: 'august',
  9: 'september',
  10: 'october',
  11: 'november',
  12: 'december'
};

type Properties = {
  employmentId: number;
};

export default function CostCalculationExternal(props: Properties) {
  const { employmentId } = props;
  const { t } = useTranslation();
  const [value, setValue] = React.useState(-1);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const currentYear = dayjs().year();
  const [selectedYear, setSelectedYear] = useState<number>(currentYear);

  const { data: years } = queries.useGetEmploymentClaYearsValid(employmentId);

  useEffect(() => {
    if (years?.indexOf(selectedYear) === -1) {
      years.sort((a, b) => {
        return Math.abs(currentYear - a) - Math.abs(currentYear - b);
      });
      setSelectedYear(years[0]);
    }
  }, [years]);

  const { data: monthRecords } = queries.useGetEmployeeCostCalculationExternal(
    employmentId,
    selectedYear
  );

  const yearOptions = years
    ?.sort()
    ?.reverse()
    ?.map((year) => ({ value: year, label: `${year}` }));

  return (
    <>
      <Box width={100}>
        <Select
          options={yearOptions || []}
          valueProp={selectedYear}
          onSelected={(value) => setSelectedYear(value)}
          fullWidth={false}
        />
      </Box>
      <StyledTabs>
        <Paper
          square
          sx={{
            position: 'sticky',
            top: 0,
            backgroundColor: '#FFF',
            zIndex: 40
          }}
        >
          <Tabs
            indicatorColor="primary"
            textColor="primary"
            value={value}
            onChange={handleChange}
          >
            <Tab label={t('yearTotals')} value={-1} />
            {Object.values(monthRecords || []).map((tab, idx) => (
              <Tab
                key={tab.month}
                label={t(`monthnames.${months[tab.month]}`)}
                value={idx}
              />
            ))}
          </Tabs>
        </Paper>
        <TabPanel key="year" index={-1} value={value} title={t('yearTotals')}>
          <CostCalculationExternalYear records={monthRecords || []} />
        </TabPanel>
        {Object.values(monthRecords || []).map((monthRecord, index) => (
          <TabPanel
            key={index}
            index={index}
            value={value}
            title={t(`monthnames.${months[monthRecord.month]}`)}
          >
            <CostCalculationExternalMonth record={monthRecord} />
          </TabPanel>
        ))}
      </StyledTabs>
    </>
  );
}
